const API = 'https://api.petertecnet.com.br';
const CNPJ = '42595409000148';
const ID = 'pt-whatsapp-fallback';

const normalize = (value) => {
  const text = String(value || '').trim();
  const match = text.match(/(?:wa\.me\/|phone=)(\d{10,15})/i);
  if (match?.[1]) return `https://wa.me/${match[1]}`;

  const digits = text.replace(/\D/g, '').replace(/^0+/, '');
  if (!digits) return null;

  const normalized = digits.startsWith('55') && digits.length >= 12 ? digits : `55${digits}`;
  return `https://wa.me/${normalized}`;
};

const fromContact = (contact) => normalize(
  contact?.whatsapp_url || contact?.whatsappUrl || contact?.whatsapp ||
  contact?.whatsapp_phone || contact?.phone || contact?.mobile || contact?.cellphone
);

export async function getPeterWhatsapp() {
  try {
    const response = await fetch(`${API}/api/ecosystem/site`, { headers: { Accept: 'application/json' } });
    if (response.ok) {
      const payload = await response.json();
      const link = fromContact(payload?.site?.contact || payload?.contact);
      if (link) return link;
    }
  } catch {}

  try {
    const response = await fetch(`${API}/api/nexus/public/catalog-by-cnpj/${CNPJ}`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    const payload = await response.json();
    return fromContact(payload?.establishment);
  } catch {
    return null;
  }
}

export function buildPeterWhatsappUrl(base, message) {
  if (!base) return null;
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}text=${encodeURIComponent(String(message || '').trim())}`;
}

const pageLabel = () => {
  const heading = document.querySelector('main h1,[role="main"] h1,h1')?.textContent?.replace(/\s+/g, ' ').trim();
  return heading && heading.length < 180
    ? heading
    : String(document.title || 'esta página').split(/[|·]/)[0].trim();
};

const hasSpecificButton = () => Array.from(
  document.querySelectorAll(`a[href*="wa.me"]:not(#${ID}),a[href*="whatsapp.com"]:not(#${ID})`)
).some((element) => getComputedStyle(element).position === 'fixed' && getComputedStyle(element).display !== 'none');

export async function installPeterWhatsappFallback() {
  if (document.getElementById(ID)) return;

  const base = await getPeterWhatsapp();
  if (!base || document.getElementById(ID)) return;

  const button = document.createElement('a');
  button.id = ID;
  button.target = '_blank';
  button.rel = 'noreferrer';
  button.textContent = 'WA';
  button.title = 'Falar com a Peter Tecnet no WhatsApp';
  button.setAttribute('aria-label', button.title);

  Object.assign(button.style, {
    position: 'fixed',
    right: '20px',
    bottom: '22px',
    width: '58px',
    height: '58px',
    borderRadius: '50%',
    background: '#25D366',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '800',
    fontSize: '14px',
    textDecoration: 'none',
    boxShadow: '0 12px 32px rgba(0,0,0,.32)',
    zIndex: '2147483000'
  });

  const sync = () => {
    button.style.display = hasSpecificButton() ? 'none' : 'flex';
    button.href = buildPeterWhatsappUrl(
      base,
      `Olá! Gostaria de saber mais informações sobre "${pageLabel()}". Você poderia me ajudar?`
    );
  };

  document.body.appendChild(button);
  sync();
  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('popstate', sync);
}
